import React from "react";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import {
  EmptyStateGradient,
  StageWorkflowEmptyIllustration
} from "@dreamhub/designsystem/icons";

interface Props {
  title: string;
  subtitle: string;
  className?: string;
}

const StageWorkflowsEmptyState: React.FC<Props> = ({
  title,
  subtitle,
  className
}) => (
  <div
    className={cn(
      "relative flex w-full h-full items-center justify-center gap-16 px-[34px] pb-[18px]",
      className
    )}
  >
    <StageWorkflowEmptyIllustration />
    <div className="absolute left-[140px] top-[70px]">
      <EmptyStateGradient />
    </div>
    <div className="flex flex-col gap-6">
      <Text variant="lgSubtitle" className="normal-case">
        {title}
      </Text>
      <Text variant="lgBodySecondary" className="max-w-[320px]">
        {subtitle}
      </Text>
    </div>
  </div>
);

export default StageWorkflowsEmptyState;
